import React from 'react';
import Grid from "@material-ui/core/Grid";
import {makeStyles} from "@material-ui/core/styles";
import OSTotaisGrid from "../../../components/OSTotaisGrid";
import {useSelector} from "react-redux";


const useStyles = makeStyles(theme => ({

    gridExterno: {
        display: 'flex',
        flexDirection:'column',
        flexwrap: 'nowrap',
        flexGrow: 3,
        //backgroundColor: 'white',
        margin: '4px',
        // padding: '4px',
        borderRadius: '15px',
        minHeight: '150px',
        width: '120px',
        alignItems: 'center'


    },
    mainGrid: {
        display: 'flex',
        flexDirection:'row',
        flexwrap: 'wrap',
        flexGrow: 12,
        alignItems: 'center',
        justifyContent: 'center'
       // alignSelf: 'stretch',
    },
    operadores: {
        display: 'flex',
        flexDirection:'column',
        flexwrap: 'wrap',
        flexGrow: 12
    },

    gridOSTotais: {
        display: 'flex',
        flexDirection:'column',
        flexwrap: 'nowrap',
        flexGrow: 3,

        margin: 0,
        padding: '4px',
        borderRadius: '15px',
        minHeight: '150px',
        marginBottom:'30px',
        // width: '120px'

    },



}));

const ProducaoView = () => {

    const classes= useStyles();

    const pneusNaCasa = useSelector( state => state.i4.pneusNaCasa);
    const pneusRecebidosHoje = useSelector( state => state.i4.pneusRecebidosHoje);
    const pneusSaidosHoje = useSelector( state => state.i4.pneusSaidosHoje);
    const recapadosHoje = useSelector( state => state.i4.recapadosHoje);

    const consertadosHoje = useSelector( state => state.i4.consertadosHoje);
    const retrabalhadosHoje = useSelector( state => state.i4.retrabalhadosHoje);

    const pneusRecusadosHoje = useSelector( state => state.i4.pneusRecusadosHoje);
    const pneusReprovadosHoje = useSelector( state => state.i4.pneusReprovadosHoje);
    const recebidosPorData = useSelector( state => state.i4.recebidosPorData);
    const enviadosPorData = useSelector( state => state.i4.enviadosPorData);
    const recapadosPorData = useSelector( state => state.i4.recapadosPorData);


    const consertadosPorData = useSelector( state => state.i4.consertadosPorData);
    const retrabalhadosPorData = useSelector( state => state.i4.retrabalhadosPorData);



    const recusadosPorData = useSelector( state => state.i4.recusadosPorData);
    const reprovadosPorData = useSelector( state => state.i4.reprovadosPorData);

    //console.log("concluidosPorData", concluidosPorData);

        return (
            <Grid item container className={classes.gridExterno} xs={12} sm={12} md={12} lg={12} xl={12}>
                <Grid container item className={classes.mainGrid} xs={12} sm={12} md={12} lg={12} xl={12}>

                    <Grid item container className={classes.gridOSTotais} xs={3} sm={3} md={3} lg={3} xl={3}>
                            <OSTotaisGrid dados={recapadosHoje} titulo={"RECAPADOS"} styleTitulo={ {color: 'green'}} legenda={"PNEUS"} historico={recapadosPorData} />
                    </Grid>
                    <Grid item container className={classes.gridOSTotais} xs={3} sm={3} md={3} lg={3} xl={3}>
                            <OSTotaisGrid dados={consertadosHoje} titulo={"VULCANIZADOS"} styleTitulo={ {color: 'green'}} legenda={"PNEUS"} historico={consertadosPorData} />
                    </Grid>
                    <Grid item container className={classes.gridOSTotais} xs={3} sm={3} md={3} lg={3} xl={3}>
                            <OSTotaisGrid dados={retrabalhadosHoje} titulo={"RETRABALHADOS"} styleTitulo={ {color: '#facd1b'}} legenda={"PNEUS"} historico={retrabalhadosPorData} />
                    </Grid>
                    <Grid item container className={classes.gridOSTotais} xs={3} sm={3} md={3} lg={3} xl={3}>
                            <OSTotaisGrid dados={pneusReprovadosHoje} styleTitulo={ {color: 'red'}} titulo={"REPROVADOS"} legenda={"PNEUS"} historico={reprovadosPorData} />
                    </Grid>
                    <Grid item container className={classes.gridOSTotais} xs={3} sm={3} md={3} lg={3} xl={3}>
                            <OSTotaisGrid dados={pneusNaCasa} titulo={"PNEUS NA CASA"} legenda={"PNEUS"}  />
                    </Grid>
                    <Grid item container className={classes.gridOSTotais} xs={3} sm={3} md={3} lg={3} xl={3}>
                            <OSTotaisGrid dados={pneusRecebidosHoje} titulo={"RECEBIDOS"} legenda={"PNEUS"} historico={recebidosPorData} />
                    </Grid>
                    <Grid item container className={classes.gridOSTotais} xs={3} sm={3} md={3} lg={3} xl={3}>
                            <OSTotaisGrid dados={pneusSaidosHoje} titulo={"ENVIADOS"} legenda={"PNEUS"} historico={enviadosPorData} />
                    </Grid>
                    <Grid item container className={classes.gridOSTotais} xs={3} sm={3} md={3} lg={3} xl={3}>
                            <OSTotaisGrid dados={pneusRecusadosHoje} styleTitulo={ {color: 'red'}} titulo={"RECUSADOS"} legenda={"PNEUS"} historico={recusadosPorData} />
                    </Grid>


                </Grid>
            </Grid>



        )
    }

export default ProducaoView;


